<template>
    <div>
        <div class="wrapper-page">
            <div class="card card-body m-2">
                <h3 class="text-center m-0">
                    <a class="logo logo-admin" href="javascript:void(0);">
                        <img alt="logo" height="45" src="/images/logo/foundri-logo.png">
                    </a>
                </h3>
                <div class="p-sm-3 p-0">
                    <form @submit.prevent="login" class="form-horizontal m-t-30">
                        <div class="form-group">
                            <label>Email</label>
                            <input :class="{ 'parsley-error' : form.errors.has('email') }" class="form-control"
                                   placeholder="Enter email"
                                   type="text"
                                   v-model="form.email">
                            <ul :class="{'filled' : form.errors.has('email')}"
                                class="parsley-errors-list">
                                <li class="parsley-required">{{ form.errors.get('email') }}</li>
                            </ul>
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input :class="{ 'parsley-error' : form.errors.has('password') }" class="form-control"
                                   placeholder="Enter password"
                                   type="password"
                                   v-model="form.password">
                            <ul :class="{'filled' : form.errors.has('password')}"
                                class="parsley-errors-list">
                                <li class="parsley-required">{{ form.errors.get('password') }}</li>
                            </ul>
                        </div>
                        <div class="form-group row mt-4">
                            <div class="col-6">
                                <router-link :to="{ name: Routes.password_email }"
                                             class="text-muted"
                                             tag="a">
                                    <i class="mdi mdi-lock"/>
                                    Forgot your password?
                                </router-link>
                            </div>
                            <div class="col-6 text-right">
                                <button :disabled="form.busy" class="btn btn-primary w-md waves-effect waves-light"
                                        type="submit">Log In
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Roles from "@/constants/roles";
    import Routes from "@/constants/routes";

    export default {
        data() {
            return {
                Routes,
                form: new Form({
                    email: null,
                    password: null
                }, {
                    email: 'required|email',
                    password: 'required'
                })
            }
        },
        methods: {
            login() {
                this.form.validate()
                    .then(() => {
                        App.post('/login', this.form)
                            .then(() => {
                                location.href = '/';
                            })
                    });
            }
        }
    }
</script>

<style scoped>

</style>
